import { makeStyles } from "@material-ui/core";
import zIndex from "@material-ui/core/styles/zIndex";


export interface StylesProps {
    searchOpen: boolean;
}

export const vmsSearchStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: "transparent",
        zIndex: zIndex.appBar + 1,
    },
    searchBody: {
        maxHeight: "90vh",
        overflow: "auto",
        transition: "max-height 0.2s linear 0.2s",
        borderTop: ({ searchOpen }: StylesProps) => searchOpen ? `1px solid ${theme.palette.primary.light}` : "none",
    },
    searchBodyHide: {
        maxHeight: 0,
        transition: "max-height 0.2s linear 0s",
    },
    searchBodyContainer: {
        backgroundColor: theme.palette.common.white,
        borderRadius: 2,
        boxShadow: "rgba(0, 0, 0, 0.3) 0px 1px 4px -1px",
    },
    searchSection: {
        margin: 16,
    },
    resultSection: {
        margin: 16,
    },
    searchInputIncrease: {
        backgroundColor: "transparent",
        minWidth: "45em",
        transition: "min-width 0.2s linear",
    },
    searchInputDecrease: {
        backgroundColor: "transparent",
        minWidth: "27em",
        transition: "min-width 0.2s linear 0.2s",
        ["@media (max-width: 1440px)"]: {
            minWidth: "10.5em",
            width: "10.5em",
        },
        ["@media only tablet"]: {
            minWidth: "5.5em",
            width: "5.5em",
        },
    },
    filterByButton: {
        marginRight: 5,
    },
}));
